"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../../api/webAApi");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var moment = require("moment");
var AffilatesPayoutsListCtl = /** @class */ (function (_super) {
    __extends(AffilatesPayoutsListCtl, _super);
    function AffilatesPayoutsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_app_payout_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_payout_id; });
        _this.dk_app_payout_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_payout_title; });
        _this.dk_app_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_title; });
        _this.dk_is_deprecated = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_deprecated; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    AffilatesPayoutsListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: []
        };
    };
    AffilatesPayoutsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "affilate language with id [" + id + "] not found !";
    };
    AffilatesPayoutsListCtl.prototype.LoadData = function (PProgramId, onDone) {
        var _this = this;
        webAApi_1.ListPProgramAppPayoutsByPProgramIdGet.exec({ pprogram_id: PProgramId }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    app_payout_id: resp.list[i].app_payout_id,
                    app_payout_title: resp.list[i].app_payout_title,
                    app_currency_title: resp.list[i].app_currency_title,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    is_deprecated: resp.list[i].is_deprecated
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AffilatesPayoutsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddPProgramAppPayout.exec({
            data: {
                app_payout_id: data.app_payout_id,
                pprogram_id: data.pprogram_id,
                is_deprecated: data.is_deprecated
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                app_payout_id: data.app_payout_id,
                app_payout_title: resp.app_payout_title,
                app_currency_title: resp.app_currency_title,
                date_changed2: moment(resp.date_changed_uts_ms).utc(false),
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                is_deprecated: data.is_deprecated
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    /*public EditData(data: IEditAffilatePayoutItem, onDone?: () => void) {

        let _tmp = this.getById(data.key);
        if (_tmp) {

            DoEditPProgramAppPayout.exec({

                data: {

                    pprogram_app_payout_id: data.key,
                    app_payout_id: data.app_payout_id,
                    is_deprecated: data.is_deprecated
                }

            }, (resp: DoEditPProgramAppPayoutResponse) => {

                _tmp.app_payout_id = data.app_payout_id;
                _tmp.app_payout_title = resp.app_payout_title;
                _tmp.is_deprecated = data.is_deprecated;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);

                this.Update();
                if (onDone) {
                    onDone();
                }

            }, (err) => {
                this._errDialog.ShowApiError(err);
            });
        }

    }*/
    AffilatesPayoutsListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    AffilatesPayoutsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeletePProgramAppPayout.exec({
                data: {
                    pprogram_app_payout_id: key,
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    AffilatesPayoutsListCtl.prototype.DoSetIsDeprecated = function (key, isDeprecated, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetPProgramAppPayoutIsDeprecated.exec({ data: { pprogram_app_payout_id: key, is_deprecated: isDeprecated } }, function (resp) {
                _tmp.is_deprecated = isDeprecated;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return AffilatesPayoutsListCtl;
}(BaseController_1.BaseController));
exports.AffilatesPayoutsListCtl = AffilatesPayoutsListCtl;
/*export interface IEditAffilatePayoutItem {

    key: number;

    app_payout_id: number;

    is_deprecated: boolean;

}*/ 



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_pprograms_list/ctl/options/AffilatesPayoutsListCtl.ts
// module id = 991
// module chunks = 0